<template>
  <svg
    width="9"
    height="14"
    viewBox="0 0 9 14"
  >
    <path d="M0.5 0C0.776142 0 1 0.223858 1 0.5V3.5C1 4.15311 1.4174 4.70873 2 4.91465V0.5C2 0.223858 2.22386 0 2.5 0C2.77614 0 3 0.223858 3 0.5V4.91465C3.5826 4.70873 4 4.15311 4 3.5V0.5C4 0.223858 4.22386 0 4.5 0C4.77614 0 5 0.223858 5 0.5V3.5C5 4.70948 4.14112 5.71836 3 5.94999V13.5C3 13.7761 2.77614 14 2.5 14C2.22386 14 2 13.7761 2 13.5V5.94999C0.85888 5.71836 0 4.70948 0 3.5V0.5C0 0.223858 0.223858 0 0.5 0ZM7.47855 1.47855C7.63761 1.31949 7.81694 1.19613 8 1.11452V6H7V2.5C7 2.16262 7.17373 1.78338 7.47855 1.47855ZM8 7V13.5C8 13.7761 8.22386 14 8.5 14C8.77614 14 9 13.7761 9 13.5V0.5C9 0.223858 8.77614 0 8.5 0C7.83738 0 7.21662 0.326274 6.77145 0.771447C6.32627 1.21662 6 1.83738 6 2.5V6.5C6 6.77614 6.22386 7 6.5 7H8Z" />
  </svg>
</template>
